module.exports = __webpack_public_path__ + "img/GH-corporate-035.2e80050e.jpg";